module.exports = __webpack_public_path__ + "static/media/gradient05.bf107fd1.jpg";